import { Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { Button, SectionHeader, Text } from "@pentabd/ui";

import { downloadEmployeeFile } from "@api/downloadEmployeeFile";

import { ROUTES } from "@constants/routes";
import { TABS } from "@constants/tab-serial";
import { useTranslation } from "react-i18next";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

type DossierEmployeeDetailsBodyPropType = {
  employeeId: string | number | undefined;
  employeeName: string;
};

export function DossierEmployeeDetailsBody({
  employeeId,
  employeeName,
}: DossierEmployeeDetailsBodyPropType) {
  const { t } = useTranslation();

  const { keycloak } = useKeycloak();
  const token = keycloak.token as string;

  return (
    <div>
      <SectionHeader title={t("DOSSIER_DETAILS.HEADER")} />
      <div className="d-flex flex-column py-9 gap-5">
        {/* short pds */}
        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.SHORT_PDS.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Button
              fill="outline"
              type="info"
              size="sm"
              onClick={() => {
                downloadEmployeeFile({
                  pdsType: "short",
                  employeeId,
                  employeeName,
                  token,
                });
              }}
            >
              {t("DOSSIER_DETAILS.SHORT_PDS.BUTTON_TEXT")}
            </Button>
          </div>
        </div>

        {/* long pds */}

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.LONG_PDS.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Button
              fill="outline"
              type="info"
              size="sm"
              onClick={() =>
                downloadEmployeeFile({
                  pdsType: "long",
                  employeeId,
                  employeeName,
                  token,
                })
              }
            >
              {t("DOSSIER_DETAILS.LONG_PDS.BUTTON_TEXT")}
            </Button>
          </div>
        </div>

        {/* view profile  */}

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.VIEW_PROFILE.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Link to={`${EMPLOYEES}/${employeeId}`}>
              <Button fill="outline" type="info" size="sm">
                {t("DOSSIER_DETAILS.VIEW_PROFILE.BUTTON_TEXT")}
              </Button>
            </Link>
          </div>
        </div>

        {/* acr view  */}

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.ACR_DETAILS.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Link to={`${EMPLOYEES}/${employeeId}?tab=${TABS.ACR}`}>
              <Button fill="outline" type="info" size="sm">
                {t("DOSSIER_DETAILS.ACR_DETAILS.BUTTON_TEXT")}
              </Button>
            </Link>
          </div>
        </div>

        {/* disipline  */}

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.PUNISHMENT_DETAILS.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Link to={`${EMPLOYEES}/${employeeId}?tab=${TABS.DISCIPLINE}`}>
              <Button fill="outline" type="info" size="sm">
                {t("DOSSIER_DETAILS.PUNISHMENT_DETAILS.BUTTON_TEXT")}
              </Button>
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("DOSSIER_DETAILS.DOSSIER_LIST.LABEL_TEXT")}
            </Text>
          </div>
          <div className="col-lg-7">
            <Link to={`${EMPLOYEES}/${employeeId}?tab=${TABS.DOSSIER}`}>
              <Button fill="outline" type="info" size="sm">
                {t("DOSSIER_DETAILS.DOSSIER_LIST.BUTTON_TEXT")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
